import { Geocoordinates } from '@guiker/base-entity'

import { Address } from './address'
import { Configuration } from './configuration'
import { Construction } from './construction'

export enum BuildingTypes {
  COMMERCIAL = 'commercial',
  CONDO = 'condo',
  MIXED = 'mixed',
  PLEX = 'plex',
  SINGLE_FAMILY = 'single-family',
}

export type Building = {
  id: string
  externalId: string
  type: BuildingTypes
  address: Address
  geocoordinates: Geocoordinates
  construction?: Construction
  configuration: Configuration
}
